"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filter_1 = __importDefault(require("./filter"));
var dateGrain_1 = require("../models/enums/dateGrain");
var rollingDateGrain_1 = require("../models/enums/rollingDateGrain");
var orderByDirection_1 = require("../models/enums/orderByDirection");
var utils_1 = __importDefault(require("../utils"));
// A simple library to help write DQL
var encapsulate = function (value) { return utils_1.default.quote(value, true); };
var handleTimeout = function (xhr, timeout) {
    if (typeof timeout === 'number' && Number.isFinite(timeout) && timeout > 0) {
        setTimeout(function () { return xhr.abort(); }, timeout);
    }
    else {
        try {
            Promise.resolve(timeout).then(function () { return xhr.abort(); });
        }
        catch (err) {
            console.log(err);
        }
    }
};
var Query = /** @class */ (function () {
    function Query() {
        this._useFiscal = false;
        this._columnNames = [];
        this._filters = [];
        this._aggregations = {};
        this._groupByColumns = [];
        this._orderByColumns = [];
        this._useBeastMode = false;
        this._useFiscal = false;
    }
    Query.prototype.useBeastMode = function (newValue) {
        if (newValue === void 0) { newValue = true; }
        this._useBeastMode = newValue;
        return this;
    };
    Query.prototype.useFiscalCalendar = function (newValue) {
        if (newValue === void 0) { newValue = true; }
        this._useFiscal = newValue;
        return this;
    };
    Query.prototype.select = function (columnNames) {
        this._columnNames = columnNames;
        return this;
    };
    Query.prototype.where = function (columnName) {
        var filter = new filter_1.default(this, columnName);
        this._filters.push(filter);
        return filter;
    };
    Query.prototype.groupBy = function (rules) {
        var _this = this;
        if (Array.isArray(rules)) {
            rules.forEach(function (column) {
                _this._groupByColumns.push(column);
            });
        }
        else if (typeof rules === 'string') {
            this._groupByColumns.push(rules);
        }
        else {
            this.aggregate(rules);
        }
        return this;
    };
    Query.prototype.dateGrain = function (columnName, grain, aggregations) {
        this._dateGrainColumn = columnName;
        this._dateGrain = grain;
        if (aggregations !== undefined) {
            this.aggregate(aggregations);
        }
        return this;
    };
    Query.prototype.previousPeriod = function (columnName, interval) {
        if (interval === void 0) { interval = dateGrain_1.DateGrain.MONTH; }
        return this.manualFilterAdd("".concat(encapsulate(columnName), " last ").concat(interval));
    };
    Query.prototype.rollingPeriod = function (columnName, interval, count) {
        if (interval === void 0) { interval = rollingDateGrain_1.RollingDateGrain.MONTHS; }
        if (count === void 0) { count = 1; }
        return this.manualFilterAdd("".concat(encapsulate(columnName), " last ").concat(count, " ").concat(interval));
    };
    Query.prototype.periodToDate = function (columnName, interval) {
        if (interval === void 0) { interval = dateGrain_1.DateGrain.MONTH; }
        return this.manualFilterAdd("".concat(encapsulate(columnName), " todate ").concat(interval));
    };
    Query.prototype.orderBy = function (columnName, direction) {
        if (direction === void 0) { direction = orderByDirection_1.OrderByDirection.ASCENDING; }
        this._orderByColumns.push({
            name: columnName,
            direction: direction,
        });
        return this;
    };
    Query.prototype.limit = function (value) {
        this._limit = value;
        return this;
    };
    Query.prototype.offset = function (value) {
        this._offset = value;
        return this;
    };
    Query.prototype.aggregate = function (aggregations) {
        this._aggregations = __assign(__assign({}, this._aggregations), aggregations);
        return this;
    };
    Query.prototype.query = function (alias) {
        var _this = this;
        var query;
        var queryOperator = '?';
        // base URL (and "select") portion
        if (this._columnNames.length) {
            (query = "/data/v2/".concat(alias, "?fields=").concat(this._columnNames
                .map(function (c) { return encodeURIComponent(c); })
                .join(', '))),
                (queryOperator = '&');
        }
        else {
            query = "/data/v2/".concat(alias);
        }
        // apply filters
        if (this._filters.length) {
            query += "".concat(queryOperator, "filter=").concat(this._filters
                .map(function (f) { return f.query(); })
                .join(', '));
            queryOperator = '&';
        }
        // add dateGrain function
        if (this._dateGrainColumn) {
            query += "".concat(queryOperator, "dategrain=").concat(encapsulate(this._dateGrainColumn), " by ").concat(this._dateGrain);
            queryOperator = '&';
        }
        // groupBy
        if (this._groupByColumns.length) {
            query += "".concat(queryOperator, "groupby=").concat(this._groupByColumns
                .map(function (c) { return encapsulate(c); })
                .join(','));
            queryOperator = '&';
        }
        // orderBy
        if (this._orderByColumns.length) {
            query += "".concat(queryOperator, "orderby=").concat(this._orderByColumns
                .map(function (col) { return "".concat(encapsulate(col.name), " ").concat(col.direction); })
                .join(', '));
            queryOperator = '&';
        }
        // aggregations
        var resolvedAggregations = Object.keys(this._aggregations).reduce(function (acc, nextAggregate) {
            var column = nextAggregate;
            var aggregationType = _this._aggregations[nextAggregate];
            if (acc[aggregationType] === undefined) {
                acc[aggregationType] = [];
            }
            acc[aggregationType].push(encapsulate(column));
            return acc;
        }, { sum: [], avg: [], count: [], unique: [], min: [], max: [] });
        Object.keys(resolvedAggregations).forEach(function (aggKey) {
            if (resolvedAggregations[aggKey].length) {
                var jointColumns = resolvedAggregations[aggKey].join(',');
                query += "".concat(queryOperator).concat(aggKey, "=").concat(jointColumns);
                queryOperator = '&';
            }
        });
        // Offset
        if (this._offset) {
            query += "".concat(queryOperator, "offset=").concat(this._offset);
            queryOperator = '&';
        }
        // Limit
        if (this._limit) {
            query += "".concat(queryOperator, "limit=").concat(this._limit);
            queryOperator = '&';
        }
        // Use fiscal calendar
        if (this._useFiscal) {
            query += "".concat(queryOperator, "calendar=").concat(this._useFiscal ? 'fiscal' : 'standard');
            queryOperator = '&';
        }
        // Use Beast Modes
        if (this._useBeastMode) {
            if (this._useBeastMode) {
                query += "".concat(queryOperator, "useBeastMode=true");
            }
            queryOperator = '&';
        }
        return query;
    };
    Query.prototype.fetch = function (alias, config) {
        var _a;
        var url = this.query(alias);
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.setRequestHeader('Accept', (_a = config === null || config === void 0 ? void 0 : config.accept) !== null && _a !== void 0 ? _a : 'application/array-of-objects');
        if (config === null || config === void 0 ? void 0 : config.timeout) {
            handleTimeout(request, config.timeout);
        }
        return new Promise(function (resolve, reject) {
            request.onload = function () {
                if (request.status >= 200 && request.status < 400) {
                    // Success!
                    try {
                        var data = JSON.parse(request.responseText);
                        resolve(data);
                    }
                    catch (err) {
                        reject(err);
                    }
                }
                else {
                    // We reached our target server, but it returned an error
                    reject(request);
                }
            };
            request.onerror = function (err) {
                // There was a connection error of some sort
                reject(err);
            };
            request.send();
        });
    };
    Query.prototype.manualFilterAdd = function (filterQuery) {
        this._filters.push({
            query: function () { return filterQuery; },
        });
        return this;
    };
    return Query;
}());
exports.default = Query;
